// eslint-disable-next-line
export const subtle = /** @type {any} */ (crypto).subtle
// eslint-disable-next-line
export const getRandomValues = /** @type {any} */ (crypto).getRandomValues.bind(crypto)
